<template>
    <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="150px"
    >
        <el-form-item label="場地" prop="roomId">
            <el-select
                    placeholder="請選擇場地"
                    v-model="form.roomId"
                    @change="onRoomChange"
            >
                <el-option
                        v-for="room in rooms"
                        :key="room.id"
                        :value="room.id"
                        :label="room.name"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="排除假日?">
            <el-checkbox v-model="form.excludeWeekend" @change="excludeWeekendChange"></el-checkbox>
        </el-form-item>
        <el-form-item label="活動日期" prop="range">
            <el-date-picker
                    type="daterange"
                    v-model="form.range"
                    :picker-options="pickerOptions"
                    start-placeholder="請選擇開始日期"
                    end-placeholder="請選擇結束日期"
                    :clearable="false"
                    @change="onRangeChange"
                    :disabled="!form.roomId"
            ></el-date-picker>

        </el-form-item>
        <el-form-item label="時段" prop="periodIds">
            <el-select
                    v-model="form.periodIds"
                    prop="periodIds"
                    multiple
                    :editable="false"
                    no-data-text="該期間查無可借用的時段"
                    :placeholder="availablePeriodsInRange.length > 0 ? '請選擇時段' : '無可用時段'"
                    :disabled="!form.roomId || form.range.length <= 0"
            >
                <el-option
                        v-for="period in availablePeriodsInRange"
                        :key="period.id"
                        :value="period.id"
                        :label="`${period.tag}(${period.timeBegin}~${period.timeEnd})`"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="註記" prop="comment">
            <el-input
                    style="width: 400px"
                    type="textarea"
                    :row="2"
                    placeholder="請輸入註記"
                    v-model="form.comment"
            ></el-input>
        </el-form-item>
        <el-button @click="submit" :loading="loading" type="primary">新增</el-button>
    </el-form>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import moment from 'moment';
    const defaultForm = {
        range: [],
        periodIds: [],
        roomId: '',
        excludeWeekend: false,
        comment: ''
    };
    export default {
        name: 'AdminBookingForm',
        data: () => ({
            form: {...defaultForm},
            rules: {
                range: [
                    {required: true, message: '請選擇預約日期起訖'}
                ],
                periodIds: [
                    {required: true, message: '請選擇時段'}
                ],
                roomId: [
                    {required: true, message: '請選擇場地'}
                ]
            },
        }),
        props:{
            loading:{
                type : Boolean,
                default: false
            }
        },
        computed: {
            ...mapState('setting', {
                rooms: state => state.rooms
            }),
            ...mapState('booking', ['periods', 'availablePeriodsInRange']),
            pickerOptions() {
                const self = this;
                return ({
                    disabledDate(date) {
                        const now = new Date();
                        return moment(date).isBefore(moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())));
                    }
                });
            },
            selectedRoom() {
                return this.rooms.find(r => r.id === this.form.roomId) || {};
            },
        },
        methods:{
            ...mapActions('booking', {
                getAvailablePeriodsInRange: 'getAvailablePeriodsInRangeSuperAction',
            }),
            ...mapActions('manage', {
                submitSuperForm : 'submitSuperFormAction'
            }),
            async onRangeChange(range){
                this.form.periodIds.splice(0);
                await this.getAvailablePeriodsInRange({
                    range: range.map(d => moment(d).format('YYYY-MM-DD')),
                    roomId: this.form.roomId,
                    allDay: this.form.excludeWeekend
                });
            },
            reset() {
                this.form = {...defaultForm};
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            },
            async submit() {
                const {form} = this.$refs;

                await form.validate(async (valid) => {
                    if (valid) {
                        const formData = {
                            ...this.form
                            , ncutRoomId: this.selectedRoom.ncutRoomId,
                            range: this.form.range.map(d => moment(d).format('YYYY-MM-DD'))
                        };

                        const {success, messages =[], status} = await this.submitSuperForm(formData);
                        if(success){
                            this.$message.success('新增成功');
                            this.reset();
                        } else{
                            this.$message.warning(messages.join(','));
                            this.form.periodIds.splice(0);
                        }
                    }
                });
            },

            onRoomChange(){
                this.form.range = [];
                this.form.periodIds = [];
            },

            excludeWeekendChange(){
                this.form.range = [];
                this.form.periodIds = [];
            }
        }
    }
</script>

<style>

</style>